import { Navigation } from "../_models/index";

export const navigation: Navigation[] = [
  {
    id: "cms_dashboards",
    title: "Tổng quan",
    translate: "NAV.DASHBOARDS",
    type: "items",
    icon: "home",
    url: "/cms/dashboard",
    exactMatch: true,
  },

  {
    id: "cms_animalslice",
    title: "Động vật chí",
    translate: "NAV.ANIMAL",
    type: "group",
    icon: "user",
    url: "/cms/animalslice",
    exactMatch: true,
    children: [
      {
        id: "cms_animalslice_taxonomy_structure",
        title: "Cấu trúc Taxon",
        translate: "NAV.ANIMAL_LIST.TAXONOMY_STRUCTURE",
        type: "items",
        url: "/cms/animalslice/Taxonomy-structure",
        exactMatch: true,
        children: [
          {
            id: "cms_animalslice_list_draft_taxonomy_structure",
            title: "Danh sách nhập liệu",
            translate:
              "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_DRAFT_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/animalslice/Taxonomy-structure/list-draft-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_animalslice_list_assign_taxonomy_structure",
            title: "Danh sách giao việc kiểm tra",
            translate:
              "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_ASSIGN_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/animalslice/Taxonomy-structure/list-assign-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_animalslice_list_check_taxonomy_structure",
            title: "Danh sách kiểm tra",
            translate:
              "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_CHECK_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/animalslice/Taxonomy-structure/list-check-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_animalslice_list_approve_taxonomy_structure",
            title: "Danh sách chờ duyệt",
            translate:
              "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_APPROVE_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/animalslice/Taxonomy-structure/list-approve-taxonomy-structure",
            exactMatch: true,
          },

          {
            id: "cms_animalslice_list_announced_taxonomy_structure",
            title: "Danh sách công bố",
            translate:
              "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_ANNOUNCED_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/animalslice/Taxonomy-structure/list-announced-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_animalslice_list_expert_taxonomy_structure",
            title: "Danh sách góp ý",
            translate:
              "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_EXPERT_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/animalslice/Taxonomy-structure/list-expert-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_animalslice_list_history_taxonomy_structure",
            title: "Lịch sử cập nhật",
            translate:
              "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_HISTORY_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/animalslice/Taxonomy-structure/list-history-taxonomy-structure",
            exactMatch: true,
          },
        ],
      },
      {
        id: "cms_animalslice_data_structure",
        title: "Cấu trúc dữ liệu",
        translate: "NAV.ANIMAL_LIST.DATA_STRUCTURES",
        type: "items",
        exactMatch: true,
        url: "/cms/animalslice/Data-structures",
        children: [
          {
            id: "cms_animalslice_list_draft_data_structure",
            title: "Danh sách nhập liệu",
            translate: "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_DRAFT_DATA",
            type: "items",
            url: "/cms/animalslice/Data-structure/list-draft-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_animalslice_list_assign_data_structure",
            title: "Danh sách giao việc",
            translate: "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_ASSIGN_DATA",
            type: "item",
            url: "/cms/animalslice/Data-structure/list-assign-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_animalslice_list_check_data_structure",
            title: "Danh sách kiểm tra",
            translate: "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_CHECK_DATA",
            type: "item",
            url: "/cms/animalslice/Data-structure/list-check-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_animalslice_list_approve_data_structure",
            title: "Danh sách chờ duyệt",
            translate: "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_APPROVE_DATA",
            type: "item",
            url: "/cms/animalslice/Data-structure/list-approve-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_animalslice_list_announced_data_structure",
            title: "Danh sách công bố",
            translate: "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_ANNOUNCED_DATA",
            type: "item",
            url: "/cms/animalslice/Data-structure/list-announced-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_animalslice_list_expert_data_structure",
            title: "Danh sách cần góp ý",
            translate: "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_EXPERT_DATA",
            type: "item",
            url: "/cms/animalslice/Data-structure/list-expert-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_animalslice_list_history_data_structure",
            title: "Lịch sử cập nhật",
            translate: "NAV.ANIMAL_LIST.ANIMAL_DETAIL.LIST_HISTORY_DATA",
            type: "item",
            url: "/cms/animalslice/Data-structure/list-history-data-structure",
            exactMatch: true,
          },
        ],
      },
    ],
  },

  

  {
    id: "cms_normalbook",
    title: "Sách thông thường",
    translate: "Sách thông thường",
    type: "group",
    icon: "user",
    url: "/cms/normalbook",
    exactMatch: true,
    children: [
      {
        id: "cms_normalbook_taxonomy_structure",
        title: "Cấu trúc Taxon",
        translate: "Cấu trúc Taxon",
        type: "items",
        url: "/cms/normalbook/Taxonomy-structure",
        exactMatch: true,
        children: [
          {
            id: "cms_normalbook_list_draft_taxonomy_structure",
            title: "Danh sách nhập liệu",
            translate:
              "Danh sách nhập liệu",
            type: "item",
            url: "/cms/normalbook/Taxonomy-structure/list-draft-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_normalbook_list_assign_taxonomy_structure",
            title: "Danh sách giao việc kiểm tra",
            translate:
              "Danh sách giao việc kiểm tra",
            type: "item",
            url: "/cms/normalbook/Taxonomy-structure/list-assign-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_normalbook_list_check_taxonomy_structure",
            title: "Danh sách kiểm tra",
            translate:
              "Danh sách kiểm tra",
            type: "item",
            url: "/cms/normalbook/Taxonomy-structure/list-check-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_normalbook_list_approve_taxonomy_structure",
            title: "Danh sách chờ duyệt",
            translate:
              "Danh sách chờ duyệt",
            type: "item",
            url: "/cms/normalbook/Taxonomy-structure/list-approve-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_normalbook_list_announced_taxonomy_structure",
            title: "Danh sách công bố",
            translate:
              "Danh sách công bố",
            type: "item",
            url: "/cms/normalbook/Taxonomy-structure/list-announced-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_normalbook_list_expert_taxonomy_structure",
            title: "Danh sách góp ý",
            translate:
              "Danh sách góp ý",
            type: "item",
            url: "/cms/normalbook/Taxonomy-structure/list-expert-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_normalbook_list_history_taxonomy_structure",
            title: "Lịch sử cập nhật",
            translate:
              "Lịch sử cập nhật",
            type: "item",
            url: "/cms/normalbook/Taxonomy-structure/list-history-taxonomy-structure",
            exactMatch: true,
          },
        ],
      },
      {
        id: "cms_normalbook_data_structure",
        title: "NAV.NORMALBOOK_LIST.DATA_STRUCTURES",
        translate: "Cấu trúc dữ liệu",
        type: "items",
        exactMatch: true,
        url: "/cms/normalbook/Data-structures",
        children: [
          {
            id: "cms_normalbook_list_draft_data_structure",
            title: "Danh sách nhập liệu",
            translate: "Danh sách nhập liệu",
            type: "items",
            url: "/cms/normalbook/Data-structure/list-draft-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_normalbook_list_assign_data_structure",
            title: "Danh sách giao việc",
            translate: "Danh sách giao việc",
            type: "item",
            url: "/cms/normalbook/Data-structure/list-assign-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_normalbook_list_check_data_structure",
            title: "Danh sách kiểm tra",
            translate: "Danh sách kiểm tra",
            type: "item",
            url: "/cms/normalbook/Data-structure/list-check-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_normalbook_list_approve_data_structure",
            title: "Danh sách chờ duyệt",
            translate: "Danh sách chờ duyệt",
            type: "item",
            url: "/cms/normalbook/Data-structure/list-approve-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_normalbook_list_announced_data_structure",
            title: "Danh sách công bố",
            translate: "Danh sách công bố",
            type: "item",
            url: "/cms/normalbook/Data-structure/list-announced-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_normalbook_list_expert_data_structure",
            title: "Danh sách cần góp ý",
            translate: "Danh sách cần góp ý",
            type: "item",
            url: "/cms/normalbook/Data-structure/list-expert-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_normalbook_list_history_data_structure",
            title: "Lịch sử cập nhật",
            translate: "Lịch sử cập nhật",
            type: "item",
            url: "/cms/normalbook/Data-structure/list-history-data-structure",
            exactMatch: true,
          },
        ],
      },
    ],
  },

  {
    id: "cms_plantlice",
    title: "Thực vật chí",
    translate: "NAV.PLANT",
    type: "group",
    icon: "user",
    url: "/cms/plantslice",
    exactMatch: true,
    children: [
      {
        id: "cms_plantlice_taxonomy_structure",
        title: "Cấu trúc Taxon",
        translate: "NAV.PLANT_LIST.CLASSIFICATION_STRUCTURE",
        type: "items",
        url: "/cms/plantslice/taxonomy-structure",
        exactMatch: true,
        children: [
          {
            id: "cms_plantlice_list_draft_taxonomy_structure",
            title: "Danh sách nhập liệu",
            translate:
              "NAV.PLANT_LIST.PLANT_DETAIL.LIST_DRAFT_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/taxonomy-structure/list-draft-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_plantlice_list_assign_taxonomy_structure",
            title: "Danh sách giao việc",
            translate:
              "NAV.PLANT_LIST.PLANT_DETAIL.LIST_ASSIGN_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/taxonomy-structure/list-assign-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_plantlice_list_check_taxonomy_structure",
            title: "Danh sách kiểm tra",
            translate:
              "NAV.PLANT_LIST.PLANT_DETAIL.LIST_CHECK_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/taxonomy-structure/list-check-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_plantlice_list_approve_taxonomy_structure",
            title: "Danh sách chờ duyệt",
            translate:
              "NAV.PLANT_LIST.PLANT_DETAIL.LIST_APPROVE_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/taxonomy-structure/list-approve-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_plantlice_list_announced_taxonomy_structure",
            title: "Danh sách công bố",
            translate:
              "NAV.PLANT_LIST.PLANT_DETAIL.LIST_ANNOUNCED_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/taxonomy-structure/list-announced-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_plantlice_list_expert_taxonomy_structure",
            title: "Danh sách góp ý",
            translate:
              "NAV.PLANT_LIST.PLANT_DETAIL.LIST_EXPERT_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/taxonomy-structure/list-expert-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_plantlice_list_history_taxonomy_structure",
            title: "Lịch sử cập nhật",
            translate:
              "NAV.PLANT_LIST.PLANT_DETAIL.LIST_HISTORY_TAXONOMY_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/taxonomy-structure/list-history-taxonomy-structure",
            exactMatch: true,
          },
        ],
      },
      {
        id: "cms_plantlice_data_structure",
        title: "Cấu trúc dữ liệu",
        translate: "NAV.PLANT_LIST.DATA_STRUCTURES",
        type: "items",
        exactMatch: true,
        url: "/cms/plantslice/data-structures",
        children: [
          {
            id: "cms_plantlice_list_draft_data_structure",
            title: "Danh sách nhập liệu",
            translate: "NAV.PLANT_LIST.PLANT_DETAIL.LIST_DRAFT_DATA_STRUCTURE",
            type: "items",
            url: "/cms/plantslice/data-structure/list-draft-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_plantlice_list_assign_data_structure",
            title: "Danh sách giao việc",
            translate: "NAV.PLANT_LIST.PLANT_DETAIL.LIST_ASSIGN_DATA_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/data-structure/list-assign-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_plantlice_list_check_data_structure",
            title: "Danh sách kiểm tra",
            translate: "NAV.PLANT_LIST.PLANT_DETAIL.LIST_CHECK_DATA_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/data-structure/list-check-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_plantlice_list_approve_data_structure",
            title: "Danh sách chờ duyệt",
            translate:
              "NAV.PLANT_LIST.PLANT_DETAIL.LIST_APPROVE_DATA_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/data-structure/list-approve-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_plantlice_list_announced_data_structure",
            title: "Danh sách công bố",
            translate:
              "NAV.PLANT_LIST.PLANT_DETAIL.LIST_ANNOUNCED_DATA_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/data-structure/list-announced-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_plantlice_list_expert_data_structure",
            title: "Danh sách góp ý",
            translate: "NAV.PLANT_LIST.PLANT_DETAIL.LIST_EXPERT_DATA_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/data-structure/list-expert-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_plantlice_list_history_data_structure",
            title: "Lịch sử cập nhật",
            translate:
              "NAV.PLANT_LIST.PLANT_DETAIL.LIST_HISTORY_DATA_STRUCTURE",
            type: "item",
            url: "/cms/plantslice/data-structure/list-history-data-structure",
            exactMatch: true,
          },
        ],
      },
    ],
  },
  {
    id: "cms_redbookslice",
    title: "Sách khác",
    translate: "Sách khác",
    type: "group",
    icon: "user",
    url: "/cms/redbookslice",
    exactMatch: true,
    children: [
      {
        id: "cms_redbookslice_taxonomy_structure",
        title: "Cấu trúc Taxon",
        translate: "Cấu trúc Taxon",
        type: "items",
        url: "/cms/redbookslice/Taxonomy-structure",
        exactMatch: true,
        children: [
          {
            id: "cms_redbookslice_list_draft_taxonomy_structure",
            title: "Danh sách nhập liệu",
            translate:
              "Danh sách nhập liệu",
            type: "item",
            url: "/cms/redbookslice/Taxonomy-structure/list-draft-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_redbookslice_list_assign_taxonomy_structure",
            title: "Danh sách giao việc kiểm tra",
            translate:
              "Danh sách giao việc kiểm tra",
            type: "item",
            url: "/cms/redbookslice/Taxonomy-structure/list-assign-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_redbookslice_list_check_taxonomy_structure",
            title: "Danh sách kiểm tra",
            translate:
              "Danh sách kiểm tra",
            type: "item",
            url: "/cms/redbookslice/Taxonomy-structure/list-check-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_redbookslice_list_approve_taxonomy_structure",
            title: "Danh sách chờ duyệt",
            translate:
              "Danh sách chờ duyệt",
            type: "item",
            url: "/cms/redbookslice/Taxonomy-structure/list-approve-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_redbookslice_list_announced_taxonomy_structure",
            title: "Danh sách công bố",
            translate:
              "Danh sách công bố",
            type: "item",
            url: "/cms/redbookslice/Taxonomy-structure/list-announced-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_redbookslice_list_expert_taxonomy_structure",
            title: "Danh sách góp ý",
            translate:
              "Danh sách góp ý",
            type: "item",
            url: "/cms/redbookslice/Taxonomy-structure/list-expert-taxonomy-structure",
            exactMatch: true,
          },
          {
            id: "cms_redbookslice_list_history_taxonomy_structure",
            title: "Lịch sử cập nhật",
            translate:
              "Lịch sử cập nhật",
            type: "item",
            url: "/cms/redbookslice/Taxonomy-structure/list-history-taxonomy-structure",
            exactMatch: true,
          },
        ],
      },
      {
        id: "cms_redbookslice_data_structure",
        title: "Cấu trúc dữ liệu",
        translate: "Cấu trúc dữ liệu",
        type: "items",
        exactMatch: true,
        url: "/cms/redbookslice/Data-structures",
        children: [
          {
            id: "cms_redbookslice_list_draft_data_structure",
            title: "Danh sách nhập liệu",
            translate: "Danh sách nhập liệu",
            type: "items",
            url: "/cms/redbookslice/Data-structure/list-draft-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_redbookslice_list_assign_data_structure",
            title: "Danh sách giao việc",
            translate: "Danh sách giao việc",
            type: "item",
            url: "/cms/redbookslice/Data-structure/list-assign-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_redbookslice_list_check_data_structure",
            title: "Danh sách kiểm tra",
                translate: "Danh sách kiểm tra",
            type: "item",
            url: "/cms/redbookslice/Data-structure/list-check-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_redbookslice_list_approve_data_structure",
            title: "Danh sách chờ duyệt",
            translate: "Danh sách chờ duyệt",
            type: "item",
            url: "/cms/redbookslice/Data-structure/list-approve-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_redbookslice_list_announced_data_structure",
            title: "Danh sách công bố",
            translate: "Danh sách công bố",
            type: "item",
            url: "/cms/redbookslice/Data-structure/list-announced-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_redbookslice_list_expert_data_structure",
            title: "Danh sách cần góp ý",
            translate: "Danh sách cần góp ý",
            type: "item",
            url: "/cms/redbookslice/Data-structure/list-expert-data-structure",
            exactMatch: true,
          },
          {
            id: "cms_redbookslice_list_history_data_structure",
            title: "Lịch sử cập nhật",
            translate: "Lịch sử cập nhật",
            type: "item",
            url: "/cms/redbookslice/Data-structure/list-history-data-structure",
            exactMatch: true,
          },
        ],
      },
    ],
  },
  {
    id: "cms_lookup",
    title: "Tra cứu",
    translate: "NAV.LOOKUP",
    type: "group",
    icon: "list",
    url: "/cms/lookup",
    exactMatch: true,
    children: [
      {
        id: "cms_lookup_search_animal",
        title: "Danh sách công bố",
        translate: "NAV.LOOKUP_LIST.SEARCH_ANIMAL",
        type: "item",
        url: "/cms/lookup/search-animal",
        exactMatch: true,
      },
      {
        id: "cms_lookup_search_plant",
        title: "Danh sách công bố",
        translate: "NAV.LOOKUP_LIST.SEARCH_PLANT",
        type: "item",
        url: "/cms/lookup/search-plant",
        exactMatch: true,
      },
    ],
  },
  {
    id: "cms_report",
    title: "Báo cáo",
    translate: "NAV.REPORT",
    type: "group",
    icon: "home",
    url: "/cms/report",
    exactMatch: true,
    children: [
      {
        id: "cms_report_animal_data_structure",
        title: "Báo cáo tổng hợp danh sách các loài động vật chí",
        translate: "NAV.REPORT_LIST.ANIMAL_DATA_STRUCTURE",
        type: "item",
        url: "/cms/report/animal-data-structure",
        exactMatch: true,
      },
      {
        id: "cms_report_animal_data_taxonomy_structure",
        title: "Báo cáo thống kê các loài động vật chí theo cấu trúc Taxon",
        translate: "NAV.REPORT_LIST.ANIMAL_DATA_TAXONOMY_STRUCTURE",
        type: "item",
        url: "/cms/report/animal-data-taxonomy-structure",
        exactMatch: true,
      },
      {
        id: "cms_report_animal_taxonomy_structure",
        title: "Báo cáo cấu trúc Taxon động vật chí",
        translate: "NAV.REPORT_LIST.ANIMAL_TAXONOMY_STRUCTURE",
        type: "item",
        url: "/cms/report/animal-taxonomy-structure",
        exactMatch: true,
      },
      {
        id: "cms_report_plant_data_structure",
        title: "Báo cáo tổng hợp danh sách các loài thực vật chí",
        translate: "NAV.REPORT_LIST.PLANT_DATA_STRUCTURE",
        type: "item",
        url: "/cms/report/plant-data-structure",
        exactMatch: true,
      },
      {
        id: "cms_report_plant_data_taxonomy_structure",
        title: "Báo cáo thống kê các loài thực vật chí theo cấu trúc Taxon",
        translate: "NAV.REPORT_LIST.PLANT_DATA_TAXONOMY_STRUCTURE",
        type: "item",
        url: "/cms/report/plant-data-taxonomy-structure",
        exactMatch: true,
      },
      {
        id: "cms_report_plant_taxonomy_structure",
        title: "Báo cáo cấu trúc Taxon thực vật chí",
        translate: "NAV.REPORT_LIST.PLANT_TAXONOMY_STRUCTURE",
        type: "item",
        url: "/cms/report/plant-taxonomy-structure",
        exactMatch: true,
      },
      {
        id: "cms_report_auth",
        title: "Báo cáo thống kê số lượng truy cập hệ thống",
        translate: "NAV.REPORT_LIST.AUTH",
        type: "item",
        url: "/cms/report/auth",
        exactMatch: true,
      },
      {
        id: "cms_report_viewmanager",
        title: "Báo cáo tổng hợp số lượng đọc theo kỳ",
        translate: "NAV.REPORT_LIST.VIEWSMANAGER",
        type: "item",
        url: "/cms/report/viewmanager",
        exactMatch: true,
      },
    ],
  },
  {
    id: "cms_masterdata",
    title: "Danh mục",
    translate: "NAV.MASTER_DATA",
    type: "group",
    icon: "list",
    url: "/cms/masterdata",
    exactMatch: true,
    children: [
      {
        id: "cms_masterdata_publishing",
        title: "Danh mục nhà xuất bản",  
        translate: "NAV.MASTER_DATA_LIST.PUBLISHING",
        type: "item",
        url: "/cms/masterdata/publishing",
        exactMatch: true,
      },
      {
        id: "cms_masterdata_book",
        title: "Sách",
        translate: "NAV.MASTER_DATA_LIST.BOOK",
        type: "item",
        url: "/cms/masterdata/book",
        exactMatch: true,
      },
      {
        id: "cms_masterdata_author",
        title: "Tác giả",
        translate: "NAV.MASTER_DATA_LIST.AUTHOR",
        type: "item",
        url: "/cms/masterdata/author",
        exactMatch: true,
      },
      {
        id: "cms_masterdata_organization",
        title: "Phòng ban",
        translate: "NAV.MASTER_DATA_LIST.ORGANIZATION",
        type: "item",
        url: "/cms/masterdata/organization",
        exactMatch: true,
      },
      {
        id: "cms_masterdata_title",
        title: "Chức danh",
        translate: "NAV.MASTER_DATA_LIST.TITLE",
        type: "item",
        url: "/cms/masterdata/title",
        exactMatch: true,
      },
      {
        id: "cms_masterdata_notificationtemplate",
        title: "Mẫu thông báo",
        translate: "NAV.MASTER_DATA_LIST.NOTIFICATION_TEMPLATE",
        type: "item",
        url: "/cms/masterdata/notificationtemplate",
        exactMatch: true,
      },
      {
        id: "cms_masterdata_groupprovice",
        title: "Danh mục",
        translate: "NAV.MASTER_DATA_LIST.GROUP_PROVICE",
        type: "items",
        exactMatch: true,
        url: "/cms/masterdata/groupprovice",
        children: [
          {
            id: "cms_masterdata_province",
            title: "Danh mục Tỉnh/Thành phố",
            translate: "NAV.MASTER_DATA_LIST.PROVINCE",
            type: "item",
            url: "/cms/masterdata/province",
            exactMatch: true,
          },
          // {
          //   id: "cms_masterdata_district",
          //   title: "Danh mục Quận/Huyện/Thị xã",
          //   translate: "NAV.MASTER_DATA_LIST.DISTRICT",
          //   type: "item",
          //   url: "/cms/masterdata/district",
          //   exactMatch: true,
          // },
          {
            id: "cms_masterdata_ward",
            title: "Danh mục tỉnh Xã/Phường/Thị Trấn",
            translate: "NAV.MASTER_DATA_LIST.WARD",
            type: "item",
            url: "/cms/masterdata/ward",
            exactMatch: true,
          },
        ],
      },
      //haohv
      {
        id: "cms_masterdata_legal-doc-manager",
        title: "Danh mục văn bản",
        translate: "NAV.MASTER_DATA_LIST.LEGAL_DOC_MANAGER",
        type: "item",
        url: "/cms/masterdata/legal-doc-manager",
        exactMatch: true,
      }
    ],
  },
  {
    id: "cms_publish",
    title: "Quản lý xuất bản",
    translate: "NAV.PUBLISH.PUBLISH_TITLE",
    type: "group",
    url: "/com/publish",
    exactMatch: true,
    children: [
      {
        id: "cms_publish_news_manager",
        title: "Quản lý bài viết",
        translate: "NAV.PUBLISH.NEWS_MANAGER.NEWS_MANAGER_TITLE",
        type: "items",
        url: "/cms/publish/news-manager",
        exactMatch: true,
        children: [
          {
            id: "cms_publish_news_manager_news",
            title: "Danh sách bài viết",
            translate: "NAV.PUBLISH.NEWS_MANAGER.NEWS",
            type: "item",
            url: "/cms/publish/news-manager/news",
            exactMatch: true,
          },
          {
            id: "cms_publish_news_manager_news_editer",
            title: "Danh sách biên tập",
            translate: "NAV.PUBLISH.NEWS_MANAGER.NEWS_EDITER",
            type: "item",
            url: "/cms/publish/news-manager/news-editer",
            exactMatch: true,
          },
          {
            id: "cms_publish_news_manager_news_browsing",
            title: "Danh sách kiểm duyệt",
            translate: "NAV.PUBLISH.NEWS_MANAGER.NEWS_BROWSING",
            type: "item",
            url: "/cms/publish/news-manager/news-browsing",
            exactMatch: true,
          },
          {
            id: "cms_publish_news_manager_news_publish",
            title: "Danh sách xuất bản",
            translate: "NAV.PUBLISH.NEWS_MANAGER.NEWS_PUBLISH",
            type: "item",
            url: "/cms/publish/news-manager/news-publish",
            exactMatch: true,
          },
          {
            id: "cms_publish_news_manager_tag",
            title: "Danh sách Tag tin tức",
            translate: "NAV.PUBLISH.NEWS_MANAGER.TAG",
            type: "item",
            url: "/cms/publish/news-manager/tag",
            exactMatch: true,
          },
        ],
      },
      {
        id: "cms_publish_categories",
        title: "Danh mục",
        translate: "NAV.PUBLISH.CATEGORIES.CATEGORY_TITLE",
        type: "items",
        url: "/cms/publish/categories",
        exactMatch: true,
        children: [
          {
            id: "cms_publish_categories_category_page",
            title: "Danh mục trang",
            translate: "NAV.PUBLISH.CATEGORIES.CATEGORY_PAGE",
            type: "item",
            url: "/cms/publish/categories/category-page",
            exactMatch: true,
          },
          {
            id: "cms_publish_categories_category_news",
            title: "Danh mục bài viết",
            translate: "NAV.PUBLISH.CATEGORIES.CATEGORY_NEWS",
            type: "item",
            url: "/cms/publish/categories/category-news",
            exactMatch: true,
          },
        ],
      },  
      {
        id: "cms_publish_news_author",
        title: "Tác giả bài viết",
        translate: "NAV.PUBLISH.NEWS_AUTHOR",
        type: "item",
        url: "/cms/publish/news-author",
        exactMatch: true,
      },
      {
        id: "cms_publish_news_comment",
        title: "Danh sách bình luận",
        translate: "NAV.PUBLISH.NEWS_COMMENT",
        type: "item",
        url: "/cms/publish/news-comment",
        exactMatch: true,
      },
      {
        id:"cms_publish_menu",
        title: "Menu",
        translate: "NAV.PUBLISH.MENU",
        type: "item",
        url: "/cms/publish/menu",
        exactMatch: true,
      },
      {
        id:"cms_publish_contact",
        title: "Liên hệ",
        translate: "NAV.PUBLISH.CONTACT",
        type: "item",
        url: "/cms/publish/contact",
        exactMatch: true,
      },
    ],
  },
  {
    id: "cms_authen",
    title: "Quản trị người dùng",
    translate: "NAV.AUTHEN",
    type: "group",
    icon: "user",
    url: "/cms/authen",
    exactMatch: true,
    children: [
      {
        id: "cms_authen_groupuser",
        title: "Nhóm quyền người dùng",
        translate: "NAV.AUTHEN_LIST.GROUP_USER",
        type: "item",
        url: "/cms/authen/groupuser",
        exactMatch: true,
      },
      {
        id: "cms_authen_user",
        title: "Người dùng hệ thống",
        translate: "NAV.AUTHEN_LIST.USER",
        type: "item",
        url: "/cms/authen/user",
        exactMatch: true,
      },
      {
        id: "cms_authen_function",
        title: "Chức năng",
        translate: "NAV.AUTHEN_LIST.FUNCTION",
        type: "item",
        url: "/cms/authen/function",
        exactMatch: true,
      },
      {
        id: "cms_authen_action",
        title: "Hành động",
        translate: "NAV.AUTHEN_LIST.ACTION",
        type: "item",
        url: "/cms/authen/action",
        exactMatch: true,
      },
      // {
      //   id: "cms_authen_diaryhistory",
      //   title: "Nhật ký hệ thống",
      //   translate: "NAV.AUTHEN_LIST.DIARYHISTORY",
      //   type: "item",
      //   url: "/cms/authen/diaryhistory",
      //   exactMatch: true,
      // },
      {
        id: "cms_authen_apilogging",
        title: "Nhật ký hệ thống",
        translate: "NAV.AUTHEN_LIST.DIARYHISTORY",
        type: "item",
        url: "/cms/authen/apilogging",
        exactMatch: true,
      },
      {
        id: "cms_authen_viewsmanager",
        title: "Quản lý lượt xem",
        translate: "NAV.AUTHEN_LIST.VIEWSMANAGER",
        type: "item",
        url: "/cms/authen/viewsmanager",
        exactMatch: true,
      },
      {
        id: "cms_authen_upload",
        title: "Quản lý file tải lên",
        translate: "NAV.AUTHEN_LIST.UPLOAD",
        type: "item",
        url: "/cms/authen/upload",
        exactMatch: true,
      },
      {
        id: "cms_authen_configurationsystem",
        title: "Cấu hình hệ thống",
        translate: "NAV.AUTHEN_LIST.CONFIGURATIONSYSTEM",
        type: "item",
        url: "/cms/authen/configurationsystem",
        exactMatch: true,
      },
      {
        id: "CMS_BACKUP",
        title: "Quản lý sao lưu dữ liệu",
        translate: "Quản lý sao lưu dữ liệu",
        type: "item",
        url: "/cms/authen/backup",
        exactMatch: true,
      },
      {
        id: "CMS_RESTORE",
        title: "Quản lý phục hồi dữ liệu",
        translate: "Quản lý phục hồi dữ liệu",
        type: "item",
        url: "/cms/authen/restore",
        exactMatch: true,
      },
      {
        id:"cms_publish_system_category",
        title: "Quản lý danh mục dùng chung hệ thống",
        translate: "Quản lý danh mục dùng chung hệ thống",
        type: "item",
        url: "/cms/publish/system-category",
        exactMatch: true,
      },
      {
        id: "cms_authen_storage_manager",
        title: "Quản lý dữ liệu",
        translate: "NAV.AUTHEN_LIST.STORAGE_MANAGER.STORAGE_TITLE",
        type: "items",
        url: "/cms/authen/storage_manager",
        exactMatch: true,
        children: [
          {
            id: "cms_authen_storage_manager_storage",
            title: "Lưu trữ tài liệu phòng ban",
            translate: "NAV.AUTHEN_LIST.STORAGE_MANAGER.STORAGE",
            type: "item",
            url: "/cms/authen/storage_manager/storage",
            exactMatch: true,
          },
          {
            id: "cms_authen_storage_manager_storage_common",
            title: "Quản lý và chia sẻ dữ liệu dùng chung",
            translate: "NAV.AUTHEN_LIST.STORAGE_MANAGER.STORAGE_COMMON",
            type: "item",
            url: "/cms/authen/storage_manager/storage-common",
            exactMatch: true,
          },
        ],
      },
    ],
  },
];
